import { render, staticRenderFns } from "./CustomAutocomplete.vue?vue&type=template&id=bab79e70&scoped=true"
import script from "./CustomAutocomplete.vue?vue&type=script&lang=ts"
export * from "./CustomAutocomplete.vue?vue&type=script&lang=ts"
import style0 from "./CustomAutocomplete.vue?vue&type=style&index=0&id=bab79e70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab79e70",
  null
  
)

export default component.exports